import React from 'react';

/* What replaces the hero on list screens. The conclusion for a list is its
   composition. Counts that describe failure render in --loss and are clickable,
   producing a FilterChip — so the route from summary to filtered view is visible. */

export function SummaryStrip({ items = [], onSelect, style }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'baseline', flexWrap: 'wrap', gap: 'var(--space-8)',
      fontSize: 'var(--num-md-size)', lineHeight: 'var(--num-md-line)', fontWeight: 'var(--num-md-weight)',
      fontVariantNumeric: 'tabular-nums slashed-zero', ...style,
    }}>
      {items.map((it, i) => (
        <React.Fragment key={it.label}>
          {i > 0 ? <span style={{ color: 'var(--text-tertiary)' }}>·</span> : null}
          {it.tone === 'loss' && onSelect ? (
            <button type="button" onClick={() => onSelect(it)} className="jmt-strip-btn"
              style={{
                background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'var(--loss)',
                font: 'inherit', fontVariantNumeric: 'tabular-nums',
              }}>{it.count} {it.label}</button>
          ) : (
            <span style={{ color: it.tone === 'loss' ? 'var(--loss)' : 'var(--text-primary)' }}>
              {it.count} <span style={{ color: it.tone === 'loss' ? 'var(--loss)' : 'var(--text-secondary)' }}>{it.label}</span>
            </span>
          )}
        </React.Fragment>
      ))}
      <style>{`.jmt-strip-btn:hover{text-decoration:underline}.jmt-strip-btn:focus-visible{outline:none;box-shadow:var(--focus-ring)}`}</style>
    </div>
  );
}
